import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import { Message, MessageOrientation } from "../alerts/Message.js";
import "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import "./validation.js";
import { DatePicker } from "./DatePicker.js";
import "./StyledInput.js";
import { FormError } from "./FormInput.js";
import "./StyledFormInputHoc.js";
import { formatDateRange } from "../../utils/date.js";
import "react-intl";
import "./DateSinglePicker.localize.js";
import "moment-timezone";
import { useDateRangePicker } from "./hooks.js";
const useStyles = makeStyles()((theme) => ({
  dateRangePicker: {
    marginBottom: 0
  },
  dateRangePickerInputSpacing: {
    paddingLeft: 0
  },
  dateRangePickerInput: {
    height: theme.custom.denseButtonHeight
  },
  dateRangePickerInputOpen: {
    border: `1px solid ${theme.palette.primary.main} !important`,
    color: theme.palette.primary.main
  },
  dateRangePickerInputEllipsis: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  infoMessage: {
    marginTop: theme.spacing(1),
    color: theme.palette.secondary.main
  }
}));
const DateRangePicker = ({
  captionComponent,
  value,
  selectedMonth,
  rangeMode = "default",
  displayMode = "desktop",
  disableFutureDates,
  type = "large",
  onChange,
  onSelect,
  locale,
  placeholder,
  pickerClassName,
  availableDateRangeForSelection,
  errorMessage,
  footer,
  hint,
  inputTooltipMessage,
  ...textInputProps
}) => {
  const {
    isDateSelected,
    isValid,
    selectedDateRange,
    error,
    handleSelect,
    handleApplyClick,
    handleCancelClick,
    handleOutsideClick,
    isDateDisabled
  } = useDateRangePicker({
    value,
    rangeMode,
    availableDateRangeForSelection,
    errorMessage,
    onChange,
    onSelect
  });
  const [open, setOpen] = useState(false);
  const { classes, cx } = useStyles();
  function handleDropdownOpen() {
    setOpen(true);
  }
  function handleDropdownClose() {
    setOpen(false);
  }
  function getFormattedValue() {
    const from = value?.from ?? availableDateRangeForSelection?.from;
    const to = value?.to ?? availableDateRangeForSelection?.to ?? (availableDateRangeForSelection?.from && disableFutureDates ? /* @__PURE__ */ new Date() : null);
    return formatDateRange(from, to);
  }
  return /* @__PURE__ */ React.createElement(
    DatePicker,
    {
      captionComponent,
      displayMode,
      isOpen: open,
      isRangeMode: true,
      isDateSelected,
      value: selectedDateRange,
      formattedValue: getFormattedValue(),
      onSelect: handleSelect,
      disabledDateMatcher: isDateDisabled,
      defaultMonthDate: selectedMonth,
      disableFutureDates,
      isApplyDisabled: !isValid || !selectedDateRange?.from,
      onApplyClick: handleApplyClick,
      onCancelClick: handleCancelClick,
      onOutsideClick: handleOutsideClick,
      onDropdownOpen: handleDropdownOpen,
      onDropdownClose: handleDropdownClose,
      placeholder,
      type,
      className: cx(classes.dateRangePicker, pickerClassName),
      locale,
      inputTooltipMessage,
      footer: /* @__PURE__ */ React.createElement(React.Fragment, null, !isValid ? /* @__PURE__ */ React.createElement(FormError, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: error.message, labelParams: error.values })) : null, footer, hint && /* @__PURE__ */ React.createElement(
        Message,
        {
          message: /* @__PURE__ */ React.createElement(LocalizedText, { label: hint }),
          messageOrientation: MessageOrientation.Inline,
          className: classes.infoMessage
        }
      )),
      InputProps: {
        classes: {
          root: cx(classes.dateRangePickerInput, { [classes.dateRangePickerInputOpen]: open }),
          input: cx(classes.dateRangePickerInputSpacing, classes.dateRangePickerInputEllipsis)
        }
      },
      ...textInputProps
    }
  );
};
export {
  DateRangePicker
};
//# sourceMappingURL=DateRangePicker.js.map
